export const initialState = {
  loading: false,
  loadingSearch: false,
  totalCount: 0,
  isSearchPage: true,
  isDisplayButton: false,
  radioSelectedOption: '',
  wnError: '',
  snError: '',
  searchTerm: '',
  selectedSearchTerm: null,
  alertMessage: '',

  autocompleteResult: [], //autocomplete data from api

  autocompleteOption: {
    warrantyPartNumber: 0,
    isSearchByWarrantyPartNumber: false,
    serialNumber: '',
    pageIndex: 1,
    recordCount: 10,
  },

  filterOptions: [], //filter options from api sr no

  selectedValSN: {
    //selected value payload from search api SN
    warrantyPartNumber: 0,
    isSearchByWarrantyPartNumber: false,
    serialNumber: '',
    pageIndex: 0,
    recordCount: 0,
  },

  selectedValWN: {
    //selected value payload from search api WN
    warrantyPartNumber: 0,
    isSearchByWarrantyPartNumber: true,
    serialNumber: '',
    pageIndex: 0,
    recordCount: 0,
  },
  searchResult: [], //grid data from search api
  warrantyDetail: [], //warranty detail data from api
  warrantyEntitlement: [], //warranty entitlement data from api
  warrantySerialNoHistory: [], //warranty serial no history data from api
  warrantyId: 0,
  detailWarrantyPartNumber: 0,
  isResultsFound: false,
  isAlert: false,
  isWPNFound: null,
  isHistoryLoading: false,
  isEntitlementLoading: false,
};
